import { utils, writeFile } from "xlsx";
import { getAllUsers } from "./services/firestoreService";

export const addZerosToScore = (score) => {
  switch (`${score}`.length) {
    case 1:
      return "000" + score;

    case 2:
      return "00" + score;

    case 3:
      return "0" + score;

    case 4:
      return score;

    default:
      return "0000";
  }
};

export const convertToExcel = async (columns) => {
  const dictionary = { termsOfService: "אישור תקנון" };
  columns.forEach((column) => {
    dictionary[column.field] = column.headerName;
  });

  const allUsers = await getAllUsers();

  const data = allUsers.map((user) => {
    const userData = {};
    userData[dictionary['firstName']] = user.firstName;
    userData[dictionary['lastName']] = user.lastName;
    userData[dictionary['email']] = user.email;
    userData[dictionary['phone']] = user.phone;
    userData[dictionary['score']] = user.score;
    userData[dictionary['termsOfService']] = user.termsOfService === 'true' ? 'כן': 'לא';
    userData[dictionary['promotions']] = user.promotions === 'true' ? 'כן': 'לא';
    userData[dictionary['createdAt']] = user.createdAt.toDate().toLocaleDateString('en-GB');
    return userData;
  });
  const workbook = utils.book_new();

  const worksheet = utils.json_to_sheet(data);

  utils.book_append_sheet(workbook, worksheet, "Sheet1");

  writeFile(workbook, "Catch-the-keff-leads.xlsx");
};
